import React, { FC } from 'react';
import { sentToBroadcaster } from '../../assets/images';
import { P, Span } from '../../components/Text/Text';

import styles from './sendToBroadcasterSuccess.module.scss';

type SendToBroadcasterSuccessPropTypes = {
    Id: number;
    DeliveryNumber: number;
}

const SendToBroadcasterSuccess: FC<SendToBroadcasterSuccessPropTypes> = ({ Id, DeliveryNumber }) => {
    return (
        <div className={styles.wrapper}>
            <img src={sentToBroadcaster} alt="sent to broadcaster" />
            <p><Span>Campaign</Span> <span>#{Id}</span> <Span>was sent to Broadcaster successfully</Span></p>
            <p><Span>Delivery number</Span>: <span>#{DeliveryNumber}</span></p>
        </div>
    );
};

export default SendToBroadcasterSuccess;